var vm;
(function () {
    'use strict';
    var controllerId = 'progressDepotOrderDetailCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, progressDepotOrderDetailCtrl)

    angular.module('app.controllers').filter('trustHtml', function ($sce) {
        return function (html) {
            return $sce.trustAsHtml(html)
        }
    })

    progressDepotOrderDetailCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$rootScope', '$state', '$stateParams', '$translate', '$window', '$timeout', '$sce','moment'];

    function progressDepotOrderDetailCtrl(common, datacontext, $http, $scope, $rootScope, $state, $stateParams, $translate, $window, $timeout, $sce,moment) {
        var config = common.config;

        vm = this;

        var constantes = {
            CRITERIA_DESGLOSED: 'D',
            CRITERIA_NODESGLOSE: 'N'
        };

        //Datepickers config
        $('#txtFromDate').datepicker({
            format: 'dd/mm/yyyy',
            autoclose : true
        });
        $('#txtToDate').datepicker({
            format: 'dd/mm/yyyy',
            autoclose : true
        });
        //Pagination config
        vm.totalItems = 0;
        vm.itemsPerPage = 10;
        vm.currentPage = 1;

        vm.carrierName = "";

        //dropdown movement type
        vm.listMovementType = [];
        vm.isAdmin = false;
        vm.isShipper = false;
        vm.isTrucker = false;
        vm.associatedCarrier = null;
        // dropdowns multiselect config
        vm.statusIndexModel = [];
        vm.statusIndexList = [];
        //vm.statusIndexList = [{id:null, label:"Seleccione"}];
        vm.criteria = {depotId : null};
        vm.statusIndexListTexts = {};
        vm.statusIndexSettings = {
            smartButtonMaxItems: 0,
            smartButtonTextConverter: function (itemText, originalItem) {
                return itemText;
            }
        };

        vm.depotOrderList = [];
        vm.fromdate = null;
        vm.maxRangeDays = 30;
        vm.todate = null;
        vm.carrierModel = {};
        vm.documenttypeList = [];
        vm.actiontypeList = [];
        vm.actiontypeList.push({ Id: 1, Code: "D", Name: "Gate In" }, { Id: 2, Code: "P", Name: "Gate Out" });
        vm.displayLoading = false;
        vm.displayInfoNoData = true;
        vm.disabledBtnSearch = false;
        vm.disabledBtnExport = false;
        vm.referenceno = "";
        vm.operationtypemovement = "";
        vm.actionTypeCode = "";
        vm.varyard = "";
        vm.varactiontype = {};
        vm.codeActionType = {};
        vm.isDocTypeDisabled = true;
        vm.isRefNoDisabled = true;

        vm.typeExport = constantes.CRITERIA_NODESGLOSE;
        vm.exportDesglosed = false;
        window.formatYesNo = function (value) {

            return value ? $translate.instant('views.progressdepotorderdetail.yes') : $translate.instant('views.progressdepotorderdetail.no');
        }
        function init() {
            setBasicInformation();
            common.activateController([vm.selectLabel = 'Seleccione', fnInitialReferenceData()])
                .then(function (data) {
                    $timeout(function () {
                        vm.criteria.depotId =  vm.statusIndexList[0].id;

                        vm.fnSetDefaultDepot();
                        vm.listMovementType.unshift({ Id: 0, Code: null, Name: vm.selectLabel });
                        vm.movementModel = vm.listMovementType[0];

                        vm.documenttypeList.unshift({ DocumentTypeId: 0, Code: null, Name: vm.selectLabel });
                        vm.vardocumenttype = vm.documenttypeList[0].DocumentTypeId;

                        vm.actiontypeList.unshift({ Id: 0, Code: null, Name: vm.selectLabel });
                        vm.varactiontype = vm.actiontypeList[0].Id;
                    }, 500);
                });

            vm.depotOrderData = [];
            vm.depotOrderDetailData = [];

            vm.fnSetDefaultDepot = function() {
                var authData = common.localStorageService.get('authorizationData');
                if (authData) {
                    var currentYardId = authData.ModelRequester.CurrentYardId;
                    if (currentYardId !== undefined)
                        vm.criteria.depotId = Number(currentYardId);
                }
            }
            vm.fnGetDateRangeSetting = function() {
                const categoryName = "Portal Reportes - Date Range";
                const settingName = "ProgressDepotOrder";
                datacontext.progressDepotOrderDetailCtrl.getApplicationSettingValue(categoryName, settingName).then(function (value) {
                    if (value) {
                        vm.maxRangeDays = Number(value);
                    }
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
            }
            vm.fnValidRangeDate = function() {
                let valid = true;
                var fromDate = moment(vm.fromdate, 'DD/MM/YYYY');
                var toDate = moment(vm.todate, 'DD/MM/YYYY');
                var days = toDate.diff(fromDate, 'days');
                if (days < 0) {
                    toastr.error($translate.instant('views.gateoperationinventory.validationFromDateGreater'));
                    valid = false;
                }
                else if (days > vm.maxRangeDays) {
                    let message = $translate.instant('views.gateoperationinventory.validationRangeDateGreater');
                    toastr.error(message.format(vm.maxRangeDays));
                    valid = false;
                }
                return valid;
            }

            vm.depotOrderDataSource = new kendo.data.DataSource({
                data: vm.depotOrderData
            });

            vm.depotOrderDetailDataSource = new kendo.data.DataSource({
                data: vm.depotOrderDetailData
            });

            vm.gridOptions = {
                dataSource: vm.depotOrderDataSource,
                sortable: false,
                pageable: {pageSizes: [10, 20, 30,50,100]},
                groupable: false,
                resizable: true,
                scrollable: true,
                height: 400,
                detailInit: function (e) {
                    var parentGrid = this;
                    $("<div id='containergrid' style='background-color:#faffa3;'/>").appendTo(e.detailCell).kendoGrid({
                        dataSource: {
                            data: parentGrid.dataItem(e.masterRow).Detail,
                            schema: {
                                model: {
                                    fields: {
                                        Status: { type: "string" },
                                        EquipmentNo: { type: "string" },
                                        Shipper: { type: "string" },
                                        Approved: { type: "boolean" },
                                        EquipmentSizeType: { type: "string" },
                                        Seals: {type: "string"},
                                        Commodity: { type: "string" },
                                        Temperature: { type: "string" },
                                        Ventilation: { type: "string" },
                                        Hummidity: { type: "string" },
                                        CO2: { type: "string" },
                                        O2: { type: "string" },
                                        Atmosphere: { type: "string" },
                                    }
                                }
                            }
                        },
                        columns: [
                            { Status: "Status", title: $translate.instant('views.progressdepotorderdetail.status'), width: "10%", template: "#= Status #" },
                            { EquipmentNo: "EquipmentNo", title: $translate.instant('views.progressdepotorderdetail.equipmentno'), width: "13%", template: "#= EquipmentNo #" },
                            { Shipper: "Shipper", title: $translate.instant('views.progressdepotorderdetail.shippername'), width: "20%", template: "#= Shipper #" },
                            { Approved: "Approved", title: $translate.instant('views.progressdepotorderdetail.approved'), width: "15%", template: '#=formatYesNo(Approved)#' },
                            { EquipmentSizeType: "EquipmentSizeType", title: $translate.instant('views.progressdepotorderdetail.equipmentsizetype'), width: "10%", template: "#= EquipmentSizeType #" },
                            { Seals: "Seals", title: $translate.instant('views.progressdepotorder.seals'), width: "10%", template: "#= Seals #" },
                            { Commodity: "Commodity", title: $translate.instant('views.progressdepotorderdetail.commodity'), width: "10%", template: '#=Commodity?Commodity:""#' },
                            { Temperature: "Temperature", title: $translate.instant('views.progressdepotorderdetail.temperature'), width: "13%", template: '#=Temperature?Temperature:""#' },
                            { Ventilation: "Ventilation", title: $translate.instant('views.progressdepotorderdetail.ventilation'), width: "7%", template: '#=Ventilation?Ventilation:""#' },
                            { Hummidity: "Hummidity", title: $translate.instant('views.progressdepotorderdetail.hummidity'), width: "7%", template: '#=Hummidity?Hummidity:""#' },
                            { CO2: "CO2", title: $translate.instant('views.progressdepotorderdetail.co2'), width: "7%", template: '#=CO2?CO2:""#' },
                            { O2: "O2", title: $translate.instant('views.progressdepotorderdetail.o2'), width: "7%", template: '#=O2?O2:""#' },
                            { Atmosphere: "Atmosphere", title: $translate.instant('views.progressdepotorderdetail.atmosphere'), width: "7%", template: '#=Atmosphere?Atmosphere:""#' },
                        ]
                    });
                },
                columns: [
                    { field: "DepotOrderId", title: "Id", width: "0px" },
                    {
                        title: $translate.instant('views.progressdepotorder.bookingNumber'),
                        field: "ReferenceDocumentNo",
                        width: "10%"
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.actionType'),
                        field: "ActionType",
                        width: "13%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.carrier'),
                        field: "CarrierName",
                        width: "20%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.operator'),
                        field: "Operator",
                        width: "15%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.depot'),
                        field: "YardName",
                        width: "10%",
                        //template: "<strong>{{dataItem.Quantity}}</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.movementtype'),
                        field: "MovementTypeName",
                        width: "10%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.bookingDate'),
                        field: "CreatedDate",
                        width: "13%",
                        template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-ddTHH:mm:ss'), 'dd-MM-yyyy') #",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.sizeType'),
                        field: "SizeType",
                        width: "7%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.quantity'),
                        field: "Quantity",
                        width: "7%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.quantityAssigned'),
                        field: "AssignedQuantity",
                        width: "7%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.authorized'),
                        field: "AuthorizationsQty",
                        width: "7%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.quantityReceived'),
                        field: "ReceivedQuantiy",
                        width: "7%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.progressdepotorder.quantityPending'),
                        field: "PendingQuantity",
                        width: "7%",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    }
                ]
            };

        }

        function SetDataSourceAsync(url, modelSchema, grid, pageSize) {
            var ds = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: url,
                        type: "POST",
                        beforeSend: function (request) {
                            showLoader();
                            var authData = common.localStorageService.get('authorizationData');
                            request.setRequestHeader("Authorization", "Bearer " + authData.access_token);
                            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                            request.setRequestHeader('ModelRequester', JSON.stringify(authData.ModelRequester));
                            request.async = false;
                        },
                        complete: function (data, status) {
                            dismissLoader();
                            console.log("SetDataSourceAsync_complete status: " + status);
                            if (status === "success") {
                                // if (grid)
                                //     $("#" + grid).data("kendoGrid").refresh();
                                vm.totalItems = data.responseJSON.Total;
                            }
                            else if (status === "error" || status === "parsererror") {
                                console.log("Ha ocurrido un error al procesar la solicitud.");
                            }
                            else if (status == "timeout") {
                                console.log("Se ha superado el tiempo de espera.");
                            }
                            else {
                                console.log(status);
                            }
                        }
                    },
                    parameterMap: function (options) {
                        var model = fnGetParametersToSearchDepotOrder(vm.currentPage, vm.itemsPerPage)
                        model.parameters = options;
                        return JSON.stringify(model);
                    }
                },
                schema: { data: "Data", total: "Total", model: modelSchema },
                pageSize: pageSize ? pageSize : 10,
                serverPaging: true,
                error: function(xhr, error) {
                    dismissLoader();
                }
            });
            return ds;
        }

        function setBasicInformation() {
            var authData = common.localStorageService.get('authorizationData');
            var roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = roleSelected === "COPAdminP" ? true : false;
            vm.isShipper = (roleSelected === "Appointment" || roleSelected === "SHI") ? true : false;
            vm.isTrucker = (roleSelected === "TRU") ? true : false;
            vm.associatedCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
            vm.varyard = authData.ModelRequester.CurrentYardId;

        }

        function fnInitialReferenceData() {
            return datacontext.progressdepotorder.getFilters()
                .then(function (data) {
                    if (data) {
                        if (data.MovementType != null && data.MovementType.length > 0) {
                            angular.forEach(data.MovementType, function (movementType, key) {
                                vm.listMovementType.push(movementType);
                            });
                        }
                        if (data.Depot != null && data.Depot.length > 0) {
                            angular.forEach(data.Depot, function (depot, key) {
                                vm.statusIndexList.push({ id: depot.Id, label: depot.Name });
                                vm.statusIndexModel.push({ id: depot.Id, label: depot.Name });
                            });
                        }
                        vm.carrierName = data.Carrier;
                        vm.CarrierId = data.CarrierId;
                    }

                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        };

        function fnGetProgressDepotOrderList() {
            clearFilters();
            //var criteria = fnGetParametersToSearchDepotOrder(vm.currentPage, vm.itemsPerPage);
            vm.displayLoading = true;
            vm.displayInfoNoData = false;
            vm.disabledBtnSearch = true;
            vm.disabledBtnExport = true;
            vm.depotOrderList = [];
            vm.totalItems = 0;

            vm.depotOrderDataSource = SetDataSourceAsync(config.basePaths.Base_Path_Resources + 'reportList/GetDepotOrderList',null, "mainReport", 10);
            vm.disabledBtnSearch = false;
            vm.displayLoading = false;
            vm.disabledBtnExport = false;
        };

        function fnGetParametersToSearchDepotOrder(pageNumber, pageSize, desglosed) {
            var criteria = {};
            var authData = common.localStorageService.get('authorizationData');
            criteria.carrierId = vm.CarrierId;
            criteria.yardId = fnGetYardSelected();
            //criteria.operationTypeMovementId = angular.copy(vm.movementModel.Id);
            criteria.operationTypeMovementId = vm.movementModel.Id == 0 ? null : vm.movementModel.Id;
            criteria.fromDate = fnConvertDateToSQLFormat(vm.fromdate);
            criteria.toDate = fnConvertDateToSQLFormat(vm.todate);
            criteria.pageNumber = parseInt(pageNumber);
            criteria.pageSize = parseInt(pageSize);
            criteria.userName = authData.username;
            criteria.languageId = authData.ModelRequester.DefaultLanguageId;
            criteria.referenceDocumentNo = vm.ReferenceDocumentNo;
            criteria.actionType = vm.actionTypeCode === "" ? null : vm.actionTypeCode;
            criteria.documentTypeId = vm.vardocumenttype == 0 ? null : vm.vardocumenttype;
            criteria.desglosed =  !!desglosed;
            criteria.parameters = { page: 1, take: 2000 };
            return criteria;
        };

        function fnGetCarrierSelected() {
            var carrierId = 0;
            if (vm.carrierModel.originalObject != undefined)
                carrierId = angular.copy(vm.carrierModel.originalObject.BusinessPartnerId);
            return carrierId;
        };

         function fnGetYardSelected() {
            var yardSelecteds = [];
            if (vm.criteria) {
                if(vm.criteria.depotId != null)
                    yardSelecteds.push(vm.criteria.depotId);
            }
            else{
                for (var i = 0, j = vm.statusIndexList.length; i < j; i++) {
                         yardSelecteds.push(vm.statusIndexList[i].id);
                }
            }
            // var yardSelecteds = [];
            // if (vm.statusIndexModel.length > 0) {
            //     for (var i = 0, j = vm.statusIndexModel.length; i < j; i++) {
            //         yardSelecteds.push(vm.statusIndexModel[i].id);
            //     }
            // }
            return yardSelecteds.toString();
        };

        function fnGetExportExcelForDepotOrder(desglosed) {
            var criteria = fnGetParametersToSearchDepotOrder(1, 2000, desglosed);

            let url_ = config.basePaths.Base_Path_Resources + 'reportList/exportProgressDepotOrder';
            var authData = common.localStorageService.get('authorizationData');
            const fileName = 'DepotOrderProgress';
            var request = new XMLHttpRequest();
            request.open('POST', url_, true);
            request.setRequestHeader("Authorization", "Bearer " + authData.access_token);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('ModelRequester', JSON.stringify(authData.ModelRequester));
            request.responseType = 'blob';
            showLoader();
            request.onload = function (e) {
                dismissLoader();
                if (this.status === 200) {
                    var blob = this.response;
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(blob, fileName);
                    }
                    else {
                        var downloadLink = window.document.createElement('a');
                        var contentTypeHeader = request.getResponseHeader("Content-Type");
                        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                        downloadLink.download = fileName;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    }
                }
            };
            request.send(JSON.stringify(criteria));
        };

        function fnClearDepotOrder() {
            var authData = common.localStorageService.get('authorizationData');
            var roleSelected = authData ? authData.userRole : "";

            //CARRIER
            if (roleSelected !== "CAR") {
                //clear line
                $scope.$broadcast('angucomplete-alt:clearInput', 'carrier');
                vm.selectedCarrierFn();
            }

            //clear depot
            //set current yard

            // var dataYards = common.localStorageService.get('yardList');
            // if (dataYards) {
            //     vm.yardInfo = dataYards;
            //     var currentYard = $(dataYards).filter(function (a, b) { return b.currentYard == "currentYard"; })[0];
            //    }

            //vm.criteria.depotId =  vm.statusIndexList[0].id;
            vm.statusIndexModel = [];
            angular.forEach(vm.statusIndexList,
                function (val, key) {
                    vm.statusIndexModel.push({ id: val.id, label: val.label });
                });

            //clear movement type
            vm.movementModel = vm.listMovementType[0];

            //clear document type
            vm.vardocumenttype = vm.documenttypeList[0].DocumentTypeId;

            //clear action type
            vm.varactiontype = vm.actiontypeList[0].Id;

            //clear from date and to date
            vm.fromdate = null;
            vm.todate = null;
            $scope.selectedReferenceNo = null;
            vm.referenceno = null;

            //clear depot order list
            vm.depotOrderList = [];
            vm.displayInfoNoData = true;
            vm.totalItems = 0;

            vm.isDocTypeDisabled = true;
            vm.isRefNoDisabled = true;
            vm.depotOrderData = [];
            vm.depotOrderDataSource = { data: vm.depotOrderData };

            //clear pagination
            vm.currentPage = 1;
            vm.itemsPerPage = 20;

            //clear reference no
            vm.ReferenceDocumentNo = null;
            //cleanReferenceDocument();

            //Action Type
            vm.actionTypeCode = "";
        }

        function fnConvertDateToSQLFormat(date) {
            var parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }

        function getDocumentTypes() {
            datacontext.appointment.getDocumentTypes("M", vm.actionTypeCode).then(function (data) {
                vm.documenttypeList = data.DocumentTypes;
                vm.documenttypeList.unshift({ DocumentTypeId: 0, Code: null, Name: vm.selectLabel });
                vm.vardocumenttype = vm.documenttypeList[0].DocumentTypeId;

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getActionTypeCodeById(actionTypeId) {
            var actionType = $(vm.actiontypeList).filter(function (a, b) { return b.Id == actionTypeId })[0];
            return actionType ? actionType.Code : "";
        }

        function getDepotOrderSearchSetting() {
            var c = vm.actionTypeCode;
            var sPar = "AllowAppointmentCreationPickup";

            if (!c)
                c = "D";

            if (c == "D")
                sPar = "AllowAppointmentCreationDropOff";

            datacontext.appointment.getDepotOrderSearchSetting(sPar).then(function (data) {
                $(data).each(function (a, b) {
                    vm.operationtypemovement = vm.operationtypemovement + b.Name + ",";
                });

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function cleanReferenceDocument() {
            vm.referenceno = "";
            $scope.selectedReferenceNo = "";
            $scope.$broadcast('angucomplete-alt:clearInput', 'referenceno');
            vm.selectedReferenceNoFn();
        }

        function clearFilters() {
            if (vm.referenceno === "" && $scope.selectedReferenceNo === "") {
                vm.vardocumenttype = 0;
                vm.isRefNoDisabled = true;
                cleanReferenceDocument();
            }
        }

        vm.getCarrierByName = function (name) {
            return datacontext.progressdepotorder.getCarrierByName(name);
        };

        vm.selectedCarrierFn = function (selected) {
            if (selected != undefined) {
                vm.carrierName = selected.originalObject.Name;
                vm.CarrierId = selected.originalObject.BusinessPartnerId;
            } else {
                vm.carrierName = null;
                vm.CarrierId = null;
            }
        };

        vm.exportProgressDepotOrder = function (desglosed) {
            if(vm.totalItems==0){
                toastr.error($translate.instant('views.progressdepotorder.msg_ValidateData'));
                return;
            }
            var valid = vm.fnValidateMandatoryFields()

            if(valid)
             valid = vm.fnValidRangeDate();
            if (!valid) return;

            fnGetExportExcelForDepotOrder(desglosed);
        };

        vm.fnValidateMandatoryFields = function(){
            var message = ""
            if ((vm.isTrucker == true || vm.isShipper == true)
                && (vm.ReferenceDocumentNo == "" || vm.ReferenceDocumentNo == null || vm.ReferenceDocumentNo == undefined))
            {
                message = $translate.instant('views.progressdepotorder.msg_MandatoryReferenceDocumentNo');
                toastr.error(message);
                return false;
            }

            if ((vm.isShipper != true && vm.isTrucker != true)
                && (vm.ReferenceDocumentNo == "" || vm.ReferenceDocumentNo == null)
                && (vm.fromdate == "" || vm.todate == "" || vm.fromdate == null || vm.todate == null))
            {
                message = $translate.instant('views.progressdepotorder.msg_MandatoryRange');
                toastr.error(message);
                return false;
            }

            return true;
        }

        vm.searchDepotOrderList = function () {
            var valid = vm.fnValidateMandatoryFields()
            if(valid == true)
            valid = vm.fnValidRangeDate();
            if (!valid) return;
            fnGetProgressDepotOrderList();
        };

        vm.pageChangeds = function () {
            fnGetProgressDepotOrderList();
        };

        vm.clear = function () {
            fnClearDepotOrder();
        };

        vm.selectActionType = function () {
            if (vm.varactiontype === 0) {
                vm.isDocTypeDisabled = true;
                vm.isRefNoDisabled = true;
                vm.actionTypeCode = getActionTypeCodeById(vm.varactiontype);
                return;
            }

            cleanReferenceDocument();
            vm.actionTypeCode = getActionTypeCodeById(vm.varactiontype);
            getDocumentTypes();
            vm.isDocTypeDisabled = false;
        };

        vm.selectDocumentType = function () {
            if (vm.vardocumenttype === 0) {
                cleanReferenceDocument();
                vm.isRefNoDisabled = true;
                return;
            }

            cleanReferenceDocument();
            getDepotOrderSearchSetting();
            vm.isRefNoDisabled = false;
        };

        vm.selectedReferenceNoFn = function (selected) {
            if (selected) {
                vm.referenceno = selected;
                $scope.selectedReferenceNo = selected.originalObject;
            } else {
                vm.referenceno = "";
                $scope.selectedReferenceNo = "";
            }
        }

        $scope.getReferenceNumsDepotOrder = function (name) {
            return datacontext.appointment.getDepotOrderByRefDocNoCriteria(name, vm.vardocumenttype, vm.actionTypeCode, vm.varyard, vm.operationtypemovement);
        };

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");

            if (mainReport) {
                mainReport.refresh();
            }
        }

        vm.startDat = function () {
            $('#txtFromDate').focus();
        };

        vm.endDat = function () {
            $('#txtToDate').focus();
        };

        function showLoader() {
            if ($(".custom-loader-div").length == 0) {
                $('body').prepend("<div class='custom-loader-div'><div class='custom-loader-image'/></div>");
                $('.custom-loader-div').attr("data-loadernumber", 0);
            }

            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", ++loadernumber);

        }

        function dismissLoader() {
            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", --loadernumber);

            if ($('.custom-loader-div').attr("data-loadernumber") == 0) {
                $(".custom-loader-div").remove();
            }
        }
        String.prototype.format = function()
        {
            var content = this;
            for (var i=0; i < arguments.length; i++)
            {
                var replacement = '{' + i + '}';
                content = content.replace(replacement, arguments[i]);
            }
            return content;
        };

        init();

    }
})();
